export const INITIAL_VALUES = {
  additionalRequirements: '',
  currencyId: '',
  employmentTypeIds: [],
  mandatoryRequirements: '',
  name: '',
  paymentPeriodId: '',
  responsibilities: '',
  salaryFrom: undefined,
  salaryTo: undefined,
  scheduleWorkIds: [],
  skills: [],
};
